import { c as _c } from "react/compiler-runtime";
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useGlobalLoaderContext } from '@module/mdrt-org/shared/components/providers/global-loader-context';
import { useUserContext } from '@module/mdrt-org/shared/components/providers/user-context';
import { OrgSharedDataTag } from '@module/mdrt-org/shared/utils/data/constants/tags';
import { objectHasEntries } from '@module/mdrt-org/shared/utils/helpers/object-has-entries';
import { getMemberDirectorySearchResults } from '../utils/get-member-directory-search-results';
import { type SearchMembersRequest } from '../utils/types';
export const useMemberDirectorySearchQuery = t0 => {
  const $ = _c(20);
  const {
    requestData
  } = t0;
  const {
    accessToken
  } = useUserContext();
  const {
    setIsNonBlockingLoaderVisible
  } = useGlobalLoaderContext();
  let t1;
  let t2;
  if ($[0] !== accessToken || $[1] !== requestData) {
    const {
      page,
      profilePictureSize,
      ...restRequestData
    } = requestData;
    t2 = useQuery;
    t1 = objectHasEntries(restRequestData) && accessToken !== undefined;
    $[0] = accessToken;
    $[1] = requestData;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== accessToken || $[5] !== requestData) {
    t3 = t4 => {
      const {
        signal
      } = t4;
      return getMemberDirectorySearchResults(accessToken, requestData, signal);
    };
    $[4] = accessToken;
    $[5] = requestData;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== requestData) {
    t4 = [OrgSharedDataTag.GET_MEMBER_DIRECTORY_SEARCH_RESULTS, requestData];
    $[7] = requestData;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t4) {
    t5 = {
      enabled: t1,
      placeholderData: keepPreviousData,
      queryFn: t3,
      queryKey: t4,
      retry: false
    };
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const {
    data,
    isFetching: isSearchResultsDataLoading
  } = t2(t5);
  let t6;
  let t7;
  if ($[13] !== isSearchResultsDataLoading || $[14] !== setIsNonBlockingLoaderVisible) {
    t6 = () => {
      setIsNonBlockingLoaderVisible(isSearchResultsDataLoading);
    };
    t7 = [isSearchResultsDataLoading, setIsNonBlockingLoaderVisible];
    $[13] = isSearchResultsDataLoading;
    $[14] = setIsNonBlockingLoaderVisible;
    $[15] = t6;
    $[16] = t7;
  } else {
    t6 = $[15];
    t7 = $[16];
  }
  useEffect(t6, t7);
  let t8;
  if ($[17] !== data || $[18] !== isSearchResultsDataLoading) {
    t8 = {
      data,
      isSearchResultsDataLoading
    };
    $[17] = data;
    $[18] = isSearchResultsDataLoading;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
};